"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMusicDuration = getMusicDuration;
exports.getMusicSrc = getMusicSrc;

function getMusicDuration(duration) {
  let retVal = 'full';

  if (duration <= 12) {
    retVal = 10;
  } else if (duration <= 17) {
    retVal = 15;
  } else if (duration <= 22) {
    retVal = 20;
  } else if (duration <= 27) {
    retVal = 25;
  } else if (duration <= 32) {
    retVal = 30;
  }

  return retVal;
}

function getMusicSrc(sources, duration) {
  if (sources === undefined || sources === null) return null;
  let src;

  if (_.isNumber(duration)) {
    src = sources[`${duration}sec`];

    if (src) {
      return src;
    }
  }

  return sources.full;
}